import React from 'react';
import { Navigate } from 'react-router-dom';
import { tokenExists } from '../api/auth';

const ProtectedRoute = ({ children }) => {
  return tokenExists() ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
